<!-- <p>dashboard works!</p> -->
<div class="app-wrapper">
  <div class="header-container">
    <app-header
      (onClickSideMenu)="onOpenDrawer()"
      (onUserLogOut)="userLogOut()"
      (onUserAccountSettings)="userAccountSettings()"
    ></app-header>
  </div>
  <div class="side-bar-drawer">
    <mat-drawer-container
      *ngIf="true"
      class="dashboard-drawer-container"
      autosize
      [ngClass]="{ 'container-closed': !showFiller }"
    >
      <mat-drawer
        *ngIf="!isDevice && !isKiosk"
        #drawer
        [ngClass]="{
          'sidebar-drawer': screenSize == ScreenType.Desktop,
          'sidebar-drawer-tablet': screenSize == ScreenType.Tablet,
          'sidebar-drawer-mobile': screenSize == ScreenType.Mobile
        }"
        mode="side"
        disableClose="true"
        opened="true"
      >
        <div style="width: 100%">
          <mat-grid-list
            cols="1"
            [rowHeight]="
              screenSize == ScreenType.Desktop
                ? '56px'
                : screenSize == ScreenType.Tablet
                ? '45px'
                : '0px'
            "
            gutterSize="15px"
          >
            <!-- <mat-grid-tile
                ><div
                  class="side-nav-bar"
                  (click)="onChangeTabSelection('search')"
                >
                  <mat-icon
                    matTooltip="Search"
                    matTooltipPosition="right"
                    class="list-icon"
                    >search</mat-icon
                  >
                  <div class="list-icon-title">{{ "search" | titlecase }}</div>
                </div></mat-grid-tile
              > -->
            <mat-grid-tile>
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile
                }"
                (click)="onChangeTabSelection('dashboard')"
              >
                <mat-icon
                  matTooltip="Dashboard"
                  matTooltipPosition="right"
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                  >home</mat-icon
                >
                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "Dashboard" | titlecase }}
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile
                }"
                (click)="onChangeTabSelection('reports')"
              >
                <mat-icon
                  matTooltip="Insights"
                  matTooltipPosition="right"
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                  >difference</mat-icon
                >
                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "Insights" | titlecase }}
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile,
                  'disabled-tile': isDisableFeature
                }"
                (click)="!isDisableFeature && onChangeTabSelection('community')"
              >
                <mat-icon
                  [matTooltip]="
                    isDisableFeature
                      ? 'Subscribe to avail this feature'
                      : 'AumYe Community'
                  "
                  matTooltipPosition="right"
                  [class.disabled]="isDisableFeature"
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                  >forum</mat-icon
                >
                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "AumYe Community" }}
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="role == 'admin'">
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile
                }"
                (click)="onChangeTabSelection('analytics')"
              >
                <mat-icon
                  matTooltip="Analytics"
                  matTooltipPosition="right"
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                  >leaderboard</mat-icon
                >
                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "Analytics" | titlecase }}
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="role != 'housekeeping'">
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile,
                  'disabled-tile': isDisableFeature
                }"
                (click)="!isDisableFeature && onChangeTabSelection('media')"
              >
                <mat-icon
                  [matTooltip]="
                    isDisableFeature
                      ? 'Subscribe to avail this feature'
                      : 'Media Wall'
                  "
                  matTooltipPosition="right"
                  [class.disabled]="isDisableFeature"
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                  >videocam</mat-icon
                >
                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "Media Wall" | titlecase }}
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="role == 'admin' || role == 'supervisor'">
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile,
                  'disabled-tile': isDisableFeature
                }"
                (click)="!isDisableFeature && onChangeTabSelection('assets')"
              >
                <mat-icon
                  [matTooltip]="
                    isDisableFeature
                      ? 'Subscribe to avail this feature'
                      : 'Asset Wall'
                  "
                  matTooltipPosition="right"
                  [class.disabled]="isDisableFeature"
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                  >camera_enhance</mat-icon
                >
                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "Assets" | titlecase }}
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile
              *ngIf="role !== 'security' && role !== 'housekeeping'"
            >
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile
                }"
                (click)="onChangeTabSelection('calendar')"
              >
                <mat-icon
                  matTooltip="Calendar"
                  matTooltipPosition="right"
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                  >calendar_month</mat-icon
                >
                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "Calendar" | titlecase }}
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="role == 'admin' || role == 'supervisor'">
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile
                }"
                (click)="onChangeTabSelection('manageuser')"
              >
                <mat-icon
                  matTooltip="Manage User"
                  matTooltipPosition="right"
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                  >supervisor_account</mat-icon
                >
                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "Manage User" | titlecase }}
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="role == 'supervisor' || role == 'admin'">
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile,
                  'disabled-tile': isDisableFeature
                }"
                (click)="!isDisableFeature && onChangeTabSelection('employee')"
              >
                <mat-icon
                  [matTooltip]="
                    isDisableFeature
                      ? 'Subscribe to avail this feature'
                      : 'Employee'
                  "
                  matTooltipPosition="right"
                  [class.disabled]="isDisableFeature"
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  event_available
                </mat-icon>

                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "Employee" | titlecase }}
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="role == 'admin' || true">
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile,
                  'disabled-tile': isDisableFeature
                }"
                (click)="!isDisableFeature && onChangeTabSelection('security')"
              >
                <mat-icon
                  [matTooltip]="
                    isDisableFeature
                      ? 'Subscribe to avail this feature'
                      : 'Location SoS'
                  "
                  matTooltipPosition="right"
                  [class.disabled]="isDisableFeature"
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                  >person_pin_circle</mat-icon
                >
                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "Location SoS" }}
                </div>
              </div>
            </mat-grid-tile>

            <mat-grid-tile *ngIf="false">
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile
                }"
                (click)="onChangeTabSelection('settings')"
              >
                <mat-icon
                  matTooltip="Settings"
                  matTooltipPosition="right"
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                  >settings</mat-icon
                >
                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "Settings" | titlecase }}
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="false">
              <div
                [ngClass]="{
                  'side-nav-bar': screenSize == ScreenType.Desktop,
                  'side-nav-bar-tablet': screenSize == ScreenType.Tablet,
                  'side-nav-bar-mobile': screenSize == ScreenType.Mobile
                }"
                (click)="onChangeTabSelection('scanQr')"
              >
                <i
                  [ngClass]="{
                    'list-icon': screenSize == ScreenType.Desktop,
                    'list-icon-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-mobile': screenSize == ScreenType.Mobile
                  }"
                  matTooltip="Scan QR/OTP"
                  matTooltipPosition="right"
                  class="fa-solid fa-qrcode"
                ></i>
                <div
                  [ngClass]="{
                    'list-icon-title': screenSize == ScreenType.Desktop,
                    'list-icon-title-tablet': screenSize == ScreenType.Tablet,
                    'list-icon-title-mobile': screenSize == ScreenType.Mobile
                  }"
                >
                  {{ "Scan QR/OTP/OTP" | titlecase }}
                </div>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </mat-drawer>
      <mat-drawer-content
        [ngClass]="{
          'dashboard-drawer-content':
            screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
          'dashboard-drawer-content-mobile': screenSize == ScreenType.Mobile
        }"
      >
        <div
          [ngClass]="{
            'dashboard-content':
              screenSize == ScreenType.Desktop ||
              screenSize == ScreenType.Tablet,
            'dashboard-content-mobile': screenSize == ScreenType.Mobile
          }"
        >
          <router-outlet></router-outlet>
          <div class="patrolling-container" *ngIf="isSecurity">
            <app-patrolling-status></app-patrolling-status>
          </div>
          <div *ngIf="!isDevice && !isKiosk">
            <app-floating-icon
              [screen]="screenSize"
              [usersList]="dashboardData.orgUserList"
              [vendorRequests]="vendorRequestsData"
              [orgEvents]="dashboardData.userEvents"
              [inventoryList]="dashboardData.userInventory"
              (onClickNoticeBoard)="onShowNoticeBoard($event)"
              (onClickedManageVisitorPass)="onOpenManageVisitorDialog()"
              (onClickedSaveUserInventory)="clickedSaveUserInventory($event)"
              (onGetInventoryList)="getInventoryList()"
              (onClickedRaiseRequest)="onRaiseRequest()"
              (onClickedVisitorLogbook)="onShowVisitorLogBook()"
            >
            </app-floating-icon>
          </div>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
  <div
    *ngIf="router.url === '/dashboard'"
    [ngClass]="{
      'footer-container':
        screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
      'footer-container-mobile': screenSize == ScreenType.Mobile
    }"
  >
    <mat-toolbar class="footer-toolbar">
      <div class="footer-message">
        <ng-container>
          Powered by &copy; Techcylops Pvt Ltd. All Rights Reserved.
        </ng-container>

        <!-- <div class="footer-links">
          <a href="#">Terms of Use</a> <span>|</span>
          <a href="#">Privacy Policy</a>
        </div> -->
      </div>
    </mat-toolbar>
  </div>

  <div
    *ngIf="screenSize == ScreenType.Mobile && !isDevice && !isKiosk"
    class="footer-icon-container mobile-view-side-nav-container"
  >
    <div
      [ngClass]="{
        'icon-container': role == 'admin' || role == 'supervisor',
        'icon-container-user':
          role == 'user' ||
          role == 'security' ||
          role == 'facility' ||
          role == 'housekeeping'
      }"
    >
      <div
        class="side-nav-bar-mobile-bottom"
        (click)="onChangeTabSelection('dashboard')"
      >
        <mat-icon class="list-icon-mobile">home</mat-icon>
        <div class="list-icon-title-mobile">
          {{ "Dashboard" | titlecase }}
        </div>
      </div>

      <div
        class="side-nav-bar-mobile-bottom"
        (click)="onChangeTabSelection('reports')"
      >
        <mat-icon class="list-icon-mobile">difference</mat-icon>
        <div class="list-icon-title-mobile">
          {{ "Insights" | titlecase }}
        </div>
      </div>
      <div
        class="side-nav-bar-mobile-bottom"
        [ngClass]="{
          'disabled-tile': isDisableFeature
        }"
        [class.disabled]="isDisableFeature"
        (click)="!isDisableFeature && onChangeTabSelection('community')"
      >
        <mat-icon
          matTooltip="AumYe Community"
          matTooltipPosition="right"
          class="list-icon-mobile"
          >forum</mat-icon
        >
        <div class="list-icon-title-mobile">
          {{ "Community" }}
        </div>
      </div>
      <div
        *ngIf="role == 'admin'"
        class="side-nav-bar-mobile-bottom"
        (click)="onChangeTabSelection('analytics')"
      >
        <mat-icon class="list-icon-mobile">leaderboard</mat-icon>
        <div class="list-icon-title-mobile">
          {{ "Analytics" | titlecase }}
        </div>
      </div>
      <div
        *ngIf="role != 'housekeeping'"
        class="side-nav-bar-mobile-bottom"
        [ngClass]="{
          'disabled-tile': isDisableFeature
        }"
        [class.disabled]="isDisableFeature"
        (click)="!isDisableFeature && onChangeTabSelection('media')"
      >
        <mat-icon class="list-icon-mobile">videocam</mat-icon>
        <div class="list-icon-title-mobile">
          {{ "Media Wall" | titlecase }}
        </div>
      </div>

      <div
        *ngIf="role == 'admin' || role == 'supervisor'"
        class="side-nav-bar-mobile-bottom"
        [ngClass]="{
          'disabled-tile': isDisableFeature
        }"
        [class.disabled]="isDisableFeature"
        (click)="!isDisableFeature && onChangeTabSelection('assets')"
      >
        <mat-icon class="list-icon-mobile">camera_enhance</mat-icon>
        <div class="list-icon-title-mobile">
          {{ "Assets" | titlecase }}
        </div>
      </div>
      <div
        *ngIf="role != 'security' && role != 'housekeeping'"
        class="side-nav-bar-mobile-bottom"
        (click)="onChangeTabSelection('calendar')"
      >
        <mat-icon class="list-icon-mobile">calendar_month</mat-icon>
        <div class="list-icon-title-mobile">
          {{ "Calendar" | titlecase }}
        </div>
      </div>
      <div
        *ngIf="role == 'admin' || role == 'supervisor'"
        class="side-nav-bar-mobile-bottom"
        (click)="onChangeTabSelection('manageuser')"
      >
        <mat-icon class="list-icon-mobile">supervisor_account</mat-icon>
        <div class="list-icon-title-mobile">
          {{ "Manage Users" | titlecase }}
        </div>
      </div>
      <div
        *ngIf="role == 'supervisor' || role == 'admin'"
        class="side-nav-bar-mobile-bottom"
        [ngClass]="{
          'disabled-tile': isDisableFeature
        }"
        [class.disabled]="isDisableFeature"
        (click)="!isDisableFeature && onChangeTabSelection('employee')"
      >
        <mat-icon class="list-icon-mobile">event_available</mat-icon>
        <div class="list-icon-title-mobile">
          {{ "employee" | titlecase }}
        </div>
      </div>

      <div
        *ngIf="role == 'admin' || true"
        class="side-nav-bar-mobile-bottom"
        [ngClass]="{
          'disabled-tile': isDisableFeature
        }"
        [class.disabled]="isDisableFeature"
        (click)="!isDisableFeature && onChangeTabSelection('security')"
      >
        <mat-icon
          matTooltip="Location SoS"
          matTooltipPosition="right"
          class="list-icon-mobile"
          >person_pin_circle</mat-icon
        >
        <div class="list-icon-title-mobile">
          {{ "Location SoS" }}
        </div>
      </div>
      <div
        *ngIf="false"
        class="side-nav-bar-mobile-bottom"
        (click)="onChangeTabSelection('settings')"
      >
        <mat-icon
          matTooltip="Settings"
          matTooltipPosition="right"
          class="list-icon-mobile"
          >settings</mat-icon
        >
        <div class="list-icon-title-mobile">
          {{ "Settings" | titlecase }}
        </div>
      </div>
      <div
        *ngIf="false"
        class="side-nav-bar-mobile-bottom"
        (click)="onChangeTabSelection('scanQr')"
      >
        <mat-icon class="list-icon-mobile">qr_code</mat-icon>
        <div class="list-icon-title-mobile">
          {{ "Scan QR/OTP" | titlecase }}
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #IncidentAlert>
  <h2 matDialogTitle>New Incident Alert</h2>
  <mat-dialog-content>
    <div class="mat-dialog-content-asset">
      <b><i></i></b>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>
      Close
    </button>
  </mat-dialog-actions>
</ng-template>
<!-- RequestDialog Message -->
<ng-template #RequestDialog>
  <h2 matDialogTitle>Requesting Advanced SoS</h2>
  <mat-dialog-content>
    <div style="display: flex; flex-direction: column; align-items: center">
      <b><i>Fetching your location!</i></b>
      <mat-spinner></mat-spinner>
    </div>
  </mat-dialog-content>
</ng-template>
